import { render } from "./AnnotationCard.vue?vue&type=template&id=3768a012&scoped=true"
import script from "./AnnotationCard.vue?vue&type=script&lang=js"
export * from "./AnnotationCard.vue?vue&type=script&lang=js"

import "./AnnotationCard.vue?vue&type=style&index=0&id=3768a012&lang=scss"
import "./AnnotationCard.vue?vue&type=style&index=1&id=3768a012&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3768a012"]])

export default __exports__